export const FLEXI_GROUP_LIST_PAGE_LIMIT = 1_000_000
